export default "__VITE_ASSET__DhWNWjmb__"